<script lang="ts">
  import { createEventDispatcher, onDestroy, onMount } from "svelte";
  import Errors from "../../Errors.svelte";
  import Label from "../Label.svelte";
  //import { AceEditor } from "svelte-ace";
  import * as ace from "ace-code";
  import * as CMode from "ace-code/src/mode/c_cpp";

  const dispatch = createEventDispatcher();

  const EDITOR_ID = `ace-editor-div:${Math.floor(Math.random() * 10000000000)}`;

  export let errors: string[] = [];
  //export let placeholder: string = "";
  export let disabled: boolean = false;
  export let required: boolean = false;
  export let value: string = "";
  export let name: string = "";
  //export let rows: number = 4;
  //export let maxlength: number = null;
  //export let small: boolean = false;
  //export let lang: string = "";

  let editor: ace.Ace.Editor;
  let backupText: string = "";
  let updating: boolean = false;

  $: displayName = required && name != "" ? name + " *" : name;

  $: watchValue(value);
  function watchValue(val: string) {
    if (!editor) return;
    if (typeof val !== "string") return;
    if (val == backupText) return;

    updating = true;

    backupText = val;

    editor.clearSelection();
    let p = editor.getCursorPosition();
    //editor.session.setValue(val);
    editor.setValue(val);
    editor.moveCursorToPosition(p);
    editor.clearSelection();

    updating = false;

    //console.log("ace received value changed");

    // if (contentBackup !== val && editor && typeof val === "string") {
    //   editor.session.setValue(val);
    //   contentBackup = val;
    // }
  }

  $: watchDisabled(disabled);
  function watchDisabled(val: boolean) {
    if (!editor) return;
    editor.setReadOnly(val);
  }

  function onKeyDown(event: KeyboardEvent) {
    if (!!event && event.keyCode == 13) {
      //event.preventDefault();
      dispatch("enter", event);
    } else {
      dispatch("keydown", event);
    }
  }

  function onBlur(event: Event) {
    dispatch("blur", event);
  }

  onMount(() => {
    //editor = Ace. .edit(EDITOR_ID);
    editor = ace.edit(EDITOR_ID);
    //editor.setValue(value, 1);
    editor.setValue(value, 1);
    //editor.setTheme("ace/theme/solarized_dark");  // does not work
    editor.session.setMode(new CMode.Mode());
    editor.session.setWrapLimit(1000);
    editor.session.setUseWrapMode(false);
    editor.setShowPrintMargin(false);

    //editor.on('input', (e: Event) => {});
    editor.on("change", () => {
      if (updating) return;

      let cv = editor.getValue();
      backupText = cv;
      //console.log("ace dispatching value changed");
      value = cv;
      // setTimeout(() => {
      //   //console.log("ace dispatching value changed");
      //   value = cv;
      // }, 0);
    });
    editor.on("blur", (e: Event) => onBlur(e));
    editor.on("input", () => onKeyDown(null));
  });

  onDestroy(() => {
    if (!!editor) {
      editor.destroy();
      editor = null;
    }
  });
</script>

<div>
  {#if name != ""}
    <Label>
      {displayName}
    </Label>
  {/if}

  <div style="width:100%;height:300px">
    <div id={EDITOR_ID} style="width:100%;height:300px" />
  </div>

  <!--
  <AceEditor
    on:selectionChange={(obj) => console.log(obj.detail)}
    on:paste={(obj) => console.log(obj.detail)}
    on:input={(obj) => console.log(obj.detail)}
    on:focus={() => console.log("focus")}
    on:documentChange={(obj) => console.log(`document change : ${obj.detail}`)}
    on:cut={() => console.log("cut")}
    on:cursorChange={() => console.log("cursor change")}
    on:copy={() => console.log("copy")}
    on:init={(editor) => console.log(editor.detail)}
    on:commandKey={(obj) => console.log(obj.detail)}
    on:changeMode={(obj) => console.log(`change mode : ${obj.detail}`)}
    on:blur={() => console.log("blur")}
    width="100%"
    height="300px"
    {lang}
    bind:value
  />
  -->

  <Errors {errors} prefix={name} />
</div>
